import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    padding: theme.spacing(4, 2),
    boxSizing: 'border-box',
  },
  iconCircle: {
    alignItems: 'center',
    backgroundColor: '#AB9157',
    borderRadius: '50%',
    color: '#FFFFFF',
    display: 'flex',
    height: 80,
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    width: 80,
    '& .MuiSvgIcon-root': {
      fontSize: 40,
      color: '#FFFFFF',
    },
    '& svg': {
      fontSize: 40,
      width: 40,
      height: 40,
      color: '#FFFFFF',
      fill: 'currentColor',
    },
  },
  heading: {
    color: theme.palette.text.primary,
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  caption: {
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
    marginBottom: theme.spacing(3),
    maxWidth: 550,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
  },
  tonalButton: {
    color: '#172024',
    backgroundColor: '#EBF0F2',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#DDE4E7',
      boxShadow: 'none',
      color: '#172024',
    },
  },
  mobileHiddenButton: {
    [theme.breakpoints.only('xs')]: {
      display: 'none',
    },
  },
  mobileBottomButtons: {
    [theme.breakpoints.only('xs')]: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
    },
  },
}))

export default useStyles
